import React, { useEffect, useRef, useState } from 'react'
import { api } from '../../../helpers/api_helper';
import { Spin } from 'antd';
import './locationSelection.scss'

const LocationSelection = ({ errorHandle, disableStatus, apiUrl, placeholder, selectedLocation, value }) => {
    const dropdownRef = useRef(null);
    const [dropdownVisibility, setDropdownVisibility] = useState(false);
    const mapLocationResponseToOptions = (data) => {
        if (data === null) {
            setError(true)
        }
        else {
            return data.location_data.map(location => ({
                label: location.display_name,
                value: location.display_name,
                lat: location.lat,
                lon: location.lon
            }));
        }
    };

    const [searchResult, setSearchResult] = useState();
    const [error, setError] = useState(false);
    const [selectedLocationLabel, setSelectedLocationLabel] = useState();
    const debounceRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [selectedLocationData , setSelectedLocationData] = useState({});

    const handleChange = (e) => {
        setDropdownVisibility(true)
        let value = e.target.value;
        if(value === ''){
            setSelectedLocationData()
        }
        setSelectedLocationLabel(value);
       
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            setLoading(true)
            api.create(apiUrl, { location: value })
                .then(response => {
                    const options = mapLocationResponseToOptions(response.data);
                    setSearchResult(options);
                    setLoading(false)
                    setError(false);
                    errorHandle(false); // Pass error status to parent
                })
                .catch(() => {
                    setLoading(false)
                    setError(true);
                    errorHandle(true); // Pass error status to parent
                    setSearchResult([]); // Clear results in case of error
                });
        }, 500);
    };


    const locationSelection = (el) => {
        setSelectedLocationLabel(el?.label)
        setDropdownVisibility(false)
    }

    useEffect(() => {
        if (value) {
            setSelectedLocationLabel(value)
        }
    }, [value])

    useEffect(() => {
        console.log('selectedLocationData', selectedLocationData)
    }, [selectedLocationData]);
    useEffect(()=>{
        if(selectedLocationLabel && searchResult){
            setSelectedLocationData(searchResult.find((obj,index)=>obj.label === selectedLocationLabel));
        }
    },[selectedLocationLabel])

    useEffect(()=>{
        selectedLocation(selectedLocationData)
    },[selectedLocationData])

    const handleOutsideClick = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisibility(false)
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    return (
        <>
            <div className="location_selection_wrap" ref={dropdownRef}>
                <div className="location_input " >
                    <input type="text" className='input_field' onChange={handleChange} value={selectedLocationLabel} placeholder={placeholder} />
                    {loading && (
                        <Spin></Spin>
                    )}
                </div>
                {(searchResult?.length > 0 && dropdownVisibility) && (
                    <div className="location_listing">
                        <ul>
                            {searchResult?.map((el, index) => {
                                return (
                                    <li
                                        className='text_sm'
                                        key={el.id}
                                        onClick={() => {
                                            locationSelection(el); // Use the correct function
                                        }}
                                    >
                                        <span>{el?.label}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                )}
            </div>

        </>
    )
}

export default LocationSelection